import PerfectScrollbar from "perfect-scrollbar";

(function($) {
    $.fn.inputFilter = function(inputFilter) {
        return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function() {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty("oldValue")) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            } else {
                this.value = "";
            }
        });
    };


    $.fn.getStripeData = async function(user_id, returnData) {
        let result;

        try {

            if(typeof returnData === 'undefined')
            {
                returnData = false;
            }
            console.log(returnData);
            loader.classList.remove('fadeOut');
            result = await $.ajax({
                url: globals.route.accounts_get_cards,
                type: 'POST',
                cache: false,
                timeout: 30000,
                dataType: 'json',
                data: {'user_id' : user_id},
                error: function(){
                    loader.classList.add('fadeOut');
                    return false;
                },
                success: function(data){
                    loader.classList.add('fadeOut');
                    console.log(data);
                    if(returnData)
                    {
                        return returnData;
                    }
                    else
                    {
                        if(data.code == 2)
                        {
                            $('.cards-list-container').fadeIn();
                            $('.showAddCardContainer').fadeIn();
                        }else if(data.code == 0) {

                            $('.cards-list-container').fadeIn();
                            $('.cards-list-container').html(data.html);
                            $('.showAddCardContainer').fadeOut();
                            }else if (data.code == 1) {
                                $('.cards-list-container').fadeIn();
                                $('.showAddCardContainer').fadeIn();
                        }
                    }
                }
            });

            return result;
        } catch (error) {
            console.error(error);
        }
    }

    $.fn.Timer = function(fn, t)
    {
        var timerObj = setInterval(fn, t);

        this.stop = function() {
            if (timerObj) {
                clearInterval(timerObj);
                timerObj = null;
            }
            return this;
        }

        // start timer using current settings (if it's not already running)
        this.start = function() {
            if (!timerObj) {
                this.stop();
                timerObj = setInterval(fn, t);
            }
            return this;
        }

        // start with new or original interval, stop current interval
        this.reset = function(newT = t) {
            t = newT;
            return this.stop().start();
        }
    }

    $.fn.waitingDialog =  function() {

        return {
            show: function(message, options){
            if (typeof message === 'undefined') {
                message = '';
            }
            if (typeof options === 'undefined') {
                options = {};
            }
            if(message !== '')
            {
                var dialog = bootbox.dialog({
                    title: message,
                    message: '<p><i class="fa fa-spin fa-spinner"></i> Loading...</p>'
                });
            }

                loader.classList.remove('fadeOut');
            },
            hide: function() {
                bootbox.hideAll();
                loader.classList.add('fadeOut');
            }
        }
    };

    $.fn.nl2br = function (str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }

        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    $.fn.getStickyNotes = function(url, container)
    {
        container.html('');
        $.post(globals.route.widgets_stickyNotes, {}, function(result){
                container.html(result.html);
            setTimeout(function(){
                $('.note-scrollable').each((index, el) => {
                    new PerfectScrollbar(el);
                });
            }, 500);

        }, 'json');
    }

    $('.search-ajax').select2({
        "theme": "bootstrap",
        ajax: {
            url: function () {
                return $(this).data('url')
            },
            type: 'POST',
            dataType: 'json',
            data: function (params) {
                return {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                    q: params.term,
                    type : $(this).data('type')
                };
            },
            processResults: function (data) {
                return {
                    results: data
                };
            },
            // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
        }
    });

    $.fn.getCurrentLocation = async function(job_id) {
        let result;

        try {

            if(typeof returnData === 'undefined')
            {
                var returnData = false;
            }


            result = await $.ajax({
                url: globals.route.getCurrentLocation,
                type: 'POST',
                cache: false,
                timeout: 30000,
                dataType: 'json',
                data: {'job_id' : job_id},
                error: function(){
                    return false;
                },
                success: function(data){

                    return data;
                }
            });

            return result;
        } catch (error) {
            console.error(error);
        }
    }

    $.fn.getDriversLocations = async function() {
        let result;

        try {

            if(typeof returnData === 'undefined')
            {
                var returnData = false;
            }


            result = await $.ajax({
                url: globals.route.getDriversLocations,
                type: 'POST',
                cache: false,
                timeout: 30000,
                dataType: 'json',
                data: {},
                error: function(){
                    return false;
                },
                success: function(data){
                    return data;
                }
            });

            return result;
        } catch (error) {
            console.error(error);
        }
    }


    $.fn.formatMoney = function(number, decPlaces, decSep, thouSep) {
        decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces,
            decSep = typeof decSep === "undefined" ? "." : decSep;
        thouSep = typeof thouSep === "undefined" ? "," : thouSep;
        var sign = number < 0 ? "-" : "";
        var i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
        var j = (j = i.length) > 3 ? j % 3 : 0;

        return sign +
            (j ? i.substr(0, j) + thouSep : "") +
            i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
            (decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : "");
    }


}(jQuery));



// WEBPACK FOOTER //
// ./resources/js/admin/functions/index.js